import { styled, keyframes } from '@mui/material/styles';

const pulsateAnimation = keyframes`
  0% {
    transform: scale(0.75);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.75);
    opacity: 0.7;
  }
  100% {
    transform: scale(0.75);
    opacity: 0.7;
  }
`;

interface PulsatingBackgroundProps {
    backgroundColor: string;
  }
  
  
export const PulsatingBackground = styled('span')<PulsatingBackgroundProps>`
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${({ backgroundColor }) => backgroundColor};
    border-radius: 50%;
    opacity: 0.7;
    animation: ${pulsateAnimation} 2s infinite;
  }
`;